import store from '@/store/index';
import { getManualMicId } from '@/modules/webrtc/getManualMicId';

export default {
  // reset mic config when media devices change
  async updateDeviceStream() {
    try {
      const oldAvailableDevices = this.availableDevices;
      const availableDevices = await this.setDeviceAvailability();
      const selectedCamera = availableDevices.cameras.find(key => key.deviceId === this.videoDevice);
      const manualMicId = getManualMicId(store.state.userId, availableDevices.mics);

      if (manualMicId) {
        this.audioDevice = manualMicId;
      } else if (store.getters['uaParser/isMobileDevice']) {
        this.audioDevice = availableDevices.mics.pop()?.deviceId;
      } else if (oldAvailableDevices.mics.length !== availableDevices.mics.length) {
        // activate default device on PC once becomes available
        const defaultMic = availableDevices.mics.find(key => key.deviceId === 'default')?.label.replace('Default - ', '');
        this.audioDevice = availableDevices.mics.find(key => key.label === defaultMic)?.deviceId ?? null;
      }

      // Remove selected devices not on the updated device stream
      if (!selectedCamera) {
        this.videoDevice = '';
        delete this.constraints.cameraId;
      }

      if (this.constraints.screen) {
        return;
      }

      if ((!this.localVideoTrack && !this.localVbackgroundTrack) && selectedCamera) {
        this.videoDevice = '';
      }

      const stream = await this.publishStreamToChannel();
      return { stream };
    } catch (error) {
      return { error };
    }
  }
}
